
import { SetupContext, computed, defineComponent } from 'vue'
import { useStore } from 'vuex'
import { HomeHospitalItem } from '@/types/HomeHospital'
import Button from '@/components/elements/Button.vue'
import FavoriteButton from '@/components/elements/FavoriteButton.vue'
import HospitalLabel from '@/components/elements/HospitalLabel.vue'
import HospitalTag from '@/components/elements/HospitalTag.vue'
import HospitalDetailGraph from '@/components/block/HospitalDetailGraph.vue'
import { useRouter } from 'vue-router'

// NOTE: リポジトリ層でのデータ変換の実例を示すため、あえてHospitalCassetteから分割しています。

export default defineComponent({
  name: 'HomeHospitalCassette',

  props: {
    hospital: {
      type: Object as () => HomeHospitalItem,
      default: () => ({})
    },
    narrow: {
      type: Boolean,
      default: false
    },
    shouldShowRequestCheckbox: {
      type: Boolean,
      default: false
    },
    shouldShowFeatures: {
      type: Boolean,
      default: true
    },
    shouldShowRequestButton: {
      type: Boolean,
      default: false
    }
  },

  components: {
    Button,
    FavoriteButton,
    HospitalLabel,
    HospitalTag,
    HospitalDetailGraph
  },

  setup(props, context: SetupContext) {
    const store = useStore()
    const router = useRouter()

    // お気に入りに追加済みの病院の場合お気に入り済みに変更
    const isAlreadyFavorite = computed(() => {
      return store.getters['home/isAlreadyFavorite'](props.hospital.id)
    })

    const favoriteButtonLabel = computed(() => {
      return isAlreadyFavorite.value ? 'お気に入り登録済み' : 'お気に入りに保存'
    })

    // FIXME: マジックナンバー。paid_flg=1やactive_flg=3の意味をコードから読み取れないので定数を定義する
    const canRequestCheck = computed((): boolean => {
      return (
        props.shouldShowRequestCheckbox &&
        props.hospital.paidFlg === 1 &&
        props.hospital.activeFlg === 3
      )
    })

    // FIXME: これもマジックナンバー
    const canShowHospitalDetail = computed((): boolean => {
      return props.hospital.activeFlg === 3
    })

    const isParticipated = computed(() => {
      return store.getters['home/isParticipated'](props.hospital.id)
    })

    const goToHospitalDetail = (hospitalId: number) => () => {
      router.push(`/search/hospital/detail/${hospitalId}`)
    }

    const goToDocumentRequest = (hospitalId: number) => () => {
      router.push(`/document_request/${hospitalId}/input`)
    }

    const onFavoriteButtonClicked = () => {
      if (isAlreadyFavorite.value) {
        store.dispatch('removeFavorite', { id: props.hospital.id })
      } else {
        store.dispatch('addFavorite', { id: props.hospital.id })
      }
    }

    const onHospitalSelectionChanged = (e: Event) => {
      if (!(e.target instanceof HTMLInputElement)) return
      context.emit('call-input-change', {
        value: e.target.value,
        checked: e.target.checked
      })
    }

    const showScoringCriteriaModal = () => {
      store.dispatch('showScoringCriteriaModal')
    }

    return {
      isAlreadyFavorite,
      favoriteButtonLabel,
      canRequestCheck,
      canShowHospitalDetail,
      isParticipated,
      goToHospitalDetail,
      goToDocumentRequest,
      onFavoriteButtonClicked,
      onHospitalSelectionChanged,
      showScoringCriteriaModal
    }
  }
})
